import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/data/articles';

export default function ArticleSection() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">{t('article_section_title')}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
          {t('article_section_subtitle')}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:-translate-y-1 transition-transform cursor-pointer"
          >
            <div className="relative h-44 w-full overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} — USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700">
                {article.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="text-base md:text-lg font-bold leading-snug text-foreground-950">
                {article.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                {article.excerpt}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 group-hover:text-primary-700">
                {t('article_read_more')}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}